/**
 * Dispatched by App.js to open the session-expired notice modal.
 * Uses an event (not direct store import) to avoid circular deps:
 * store -> authSlice -> logout -> sessionExpiredNotice -> store
 */
import {
  SESSION_EXPIRED_NOTICE_FLAG,
  setSessionExpiredNoticePending,
  hasSessionExpiredNoticePending,
  clearSessionExpiredNoticePending,
  consumeSessionExpiredNoticePending
} from './sessionExpiredNoticeFlags';

export const SHOW_SESSION_EXPIRED_NOTICE_EVENT = 'showSessionExpiredNotice';

export {
  SESSION_EXPIRED_NOTICE_FLAG,
  setSessionExpiredNoticePending,
  hasSessionExpiredNoticePending,
  clearSessionExpiredNoticePending,
  consumeSessionExpiredNoticePending
};

/**
 * Request the global session-expired notice modal (handled in App.js).
 * @param {{ clearSession?: boolean }} options
 */
export const showSessionExpiredNotice = ({ clearSession = true } = {}) => {
  setSessionExpiredNoticePending();
  window.dispatchEvent(
    new CustomEvent(SHOW_SESSION_EXPIRED_NOTICE_EVENT, {
      detail: { clearSession }
    })
  );
};
